import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';

import {List} from './components';
import {SingleCalendar, Site, Deal} from '../ECDI/components';
import {getScreenshotList, getSiteList, getDealList} from '../../apis/api';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    }
}));

const Error = () => (<div>Error</div>);

const Screentshot = () => {
    const classes = useStyles();

    const [siteList, setSiteList] = useState([]);
    const [site, setSite] = useState({});
    const [dealList, setDealList] = useState([]);
    const [deal, setDeal] = useState({});
    const [screenshotList, setScreenshotList] = useState([]);

    const handleChangeSite = (site) => {
        setSite(site);

        getDealList(site.code)
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setDealList(res);
            }).catch(() => {
                return errorHandler();
            });
    }

    const handleChangeDeal = (deal) => {
        setDeal(deal);
    }

    const handleSubmit = ({targetDate}) => {
        const {code: siteCode} = site;
        const {code: dealCode} = deal;

        if (siteCode && dealCode && targetDate) {
            getScreenshotList(siteCode, dealCode, targetDate)
                .then((res) => {
                    if (res.statusCode === 0) return errorHandler();

                    setScreenshotList(res);
                }).catch(() => {
                    return errorHandler();
                });
        } else {
            alert('검색 옵션을 선택해주세요.');
        }
    };

    const errorHandler = () => <Error />;

    useEffect(() => {
        getSiteList()
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setSiteList(res);
            }).catch(() => {
                return errorHandler();
            });
    }, []);

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    lg={4}
                    md={4}
                    xl={4}
                    xs={12}
                >
                    <Site
                        siteList={siteList}
                        onChange={handleChangeSite}
                    />
                </Grid>
                <Grid
                    item
                    lg={4}
                    md={4}
                    xl={4}
                    xs={12}
                >
                    <Deal
                        dealList={dealList}
                        onChange={handleChangeDeal}
                    />
                </Grid>
                <Grid
                    item
                    lg={4}
                    md={4}
                    xl={4}
                    xs={12}
                >
                    <SingleCalendar
                        date_option={{
                            format: 'yyyy/MM/dd',
                            label: 'target date',
                            openTo: 'date',
                            views: ['year', 'month', 'date'],
                            date: new Date()
                        }}
                        term="daily"
                        onSubmit={handleSubmit}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <List data={screenshotList} />
                </Grid>
            </Grid>
        </div>
    );
};

Screentshot.propTypes = {};

export default Screentshot;
